import { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { SkillsSection } from './components/SkillsSection';
import { ContentSection } from './components/ContentSection';
import { InsideSection } from './components/InsideSection';
import { OffersSection } from './components/OffersSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { LegalFooter } from './components/LegalFooter';
function App() {
  // Meta Pixel
  useEffect(() => {
    const pixelId = '2411207615977952';
    // @ts-ignore
    if (!window.fbq) {
      // @ts-ignore
      const n: any = window.fbq = function () {
        // @ts-ignore
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    // @ts-ignore
    fbq('init', pixelId);
    // @ts-ignore
    fbq('track', 'PageView');
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      if (document.head.contains(noscript)) {
        document.head.removeChild(noscript);
      }
    };
  }, []);
  return <div className="min-h-screen w-full bg-industrial font-sans text-crudo selection:bg-electrico selection:text-white" data-id="element-0" data-mp="3dl4n5uey3vz1">
      <main data-id="element-1" data-mp="nur948fv0n11">
        <HeroSection data-id="element-2" data-mp="nv12m6045cbh" />
        <SkillsSection data-id="element-3" data-mp="nxww9i4xheu4" />
        <ContentSection data-id="element-4" data-mp="sudoanf90dch" />
        <InsideSection data-id="element-5" data-mp="stkoy7imcq4d" />
        <OffersSection data-id="element-6" data-mp="sssqmoxn0eae" />
        <FaqSection data-id="element-7" data-mp="swghthfm0oly" />
        <FinalCtaSection data-id="element-8" data-mp="35ypsmahfq2i" />
      </main>
      <LegalFooter data-id="element-9" data-mp="34x1hg4gh72u" />
    </div>;
}
export { App };